// 납입지시 - ERP_CKD 출하관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const ROM3I = lazy(() => import('@/pages/A03/ROM3I'));  // 납품서발행
const ROM3K = lazy(() => import('@/pages/A03/ROM3K'));  // 발행취소/재인쇄
const ROM4K = lazy(() => import('@/pages/A03/ROM4K'));  // 부품식별표(중포장)
const ROM4R = lazy(() => import('@/pages/A03/ROM4R'));  // 부품식별표(용기)
const ROM4X = lazy(() => import('@/pages/A03/ROM4X'));  // 부품식별표(중포장2D)
const ROM4Q = lazy(() => import('@/pages/A03/ROM4Q'));  // 출하정보전송
const ROM4T = lazy(() => import('@/pages/A03/ROM4T'));  // 납품서 삭제내역
const ROMAA = lazy(() => import('@/pages/A03/ROMAA'));  // 납품서 그룹발행
const ROMAB = lazy(() => import('@/pages/A03/ROMAB'));  // 납품서 발행취소/재인쇄

function A03() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/A03/ROM3I" component={ROM3I} />
        <Route path="/A03/ROM3K" component={ROM3K} />
        <Route path="/A03/ROM4K" component={ROM4K} />
        <Route path="/A03/ROM4R" component={ROM4R} />
        <Route path="/A03/ROM4X" component={ROM4X} />
        <Route path="/A03/ROM4Q" component={ROM4Q} />
        <Route path="/A03/ROM4T" component={ROM4T} />
        <Route path="/A03/ROMAA" component={ROMAA} />
        <Route path="/A03/ROMAB" component={ROMAB} />
      </Switch>
    </Suspense>
  );
}

export default A03;
